//LOGIN_WITH_TOKEN_KEY
export const LOGIN_WITH_TOKEN_KEY = "LOGIN_WITH_TOKEN_KEY";
export const LOGIN_WITH_TOKEN_KEY_SUCCESS = "LOGIN_WITH_TOKEN_KEY_SUCCESS";
export const LOGIN_WITH_TOKEN_KEY_FAIL = "LOGIN_WITH_TOKEN_KEY_FAIL";

// Register Guest to event
export const REGISTER_GUEST_TO_EVENT = "REGISTER_GUEST_TO_EVENT";
export const REGISTER_GUEST_TO_EVENT_SUCCESS =
  "REGISTER_GUEST_TO_EVENT_SUCCESS";
export const REGISTER_GUEST_TO_EVENT_FAIL = "REGISTER_GUEST_TO_EVENT_FAIL";
